import { Clock } from "lucide-react";
import { gbp, imgSrc } from "@/lib/api";

export const DealCard = ({ d }) => (
  <article data-testid={`completed-deal-card-${d.id}`} className="group relative overflow-hidden bg-[#121417] text-white min-h-[380px] flex items-end">
    {d.images?.[0] && (
      <img src={imgSrc(d.images[0])} alt={d.title} loading="lazy"
        className="absolute inset-0 h-full w-full object-cover opacity-70 transition-transform duration-[1.4s] group-hover:scale-105" />
    )}
    <div className="absolute inset-0 bg-gradient-to-t from-[#121417] via-[#121417]/40 to-transparent" />
    <div className="relative p-7 w-full">
      <div className="flex items-center gap-2">
        <span className="px-2.5 py-1 bg-[#9F7E44] font-plex text-[11px] uppercase tracking-wider">Completed</span>
        {d.is_sample && <span className="px-2.5 py-1 bg-white/15 font-plex text-[11px] uppercase tracking-wider">Sample</span>}
      </div>
      <h3 className="mt-4 font-display text-2xl leading-snug">{d.title}</h3>
      <p className="mt-1 font-plex text-xs text-white/70">{d.area}{d.completed_date ? ` · ${d.completed_date}` : ""}</p>
      <div className="mt-4 flex flex-wrap gap-5 text-sm">
        {d.sale_price != null && <span className="font-display text-xl text-[#E2C58F]">{gbp(d.sale_price)}</span>}
        {d.days_to_complete != null && (
          <span className="inline-flex items-center gap-1.5 text-white/85"><Clock className="h-4 w-4" /> {d.days_to_complete} days to complete</span>
        )}
      </div>
      {d.summary && <p className="mt-3 text-sm text-white/75 leading-relaxed line-clamp-3">{d.summary}</p>}
    </div>
  </article>
);
